import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the tch account api
 */
export class TchAccountService extends BaseService {

	constructor() {	
		super();
	}
	
	async getTCHAccounts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/tch-accounts' + params);		
		return data;		
	}
	
	async getTCHAccount(tchAccountId) {
		var data = await this.makeGETRequest('/api/resource/tch-accounts/' + tchAccountId);		
		return data;		
	}
	
	async saveTCHAccount(tchAccount, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/tch-accounts/' + tchAccount.tchAccountId, tchAccount);
		} else {
			saved = await this.makePOSTRequest('/api/resource/tch-accounts', tchAccount);
		}
		return saved;		
	}	
	
	async updateTCHAccountStatus(tchAccountId, active) {
		var data;
		if (active) {
			data = await this.makePUTRequest('/api/resource/tch-accounts/' + tchAccountId + '/activate');		
		} else {
			data = await this.makePUTRequest('/api/resource/tch-accounts/' + tchAccountId + '/inactivate');	
		}
		
		return data;		
	}
	
}

